const ALLOWED_KEYS = new Set(['active', 'plan', 'renewalDate', 'points', 'discountPercent', 'earlyAccess', 'downloads']);

function isValidStatus(value) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
  if (Object.keys(value).some((key) => !ALLOWED_KEYS.has(key))) return false;
  return typeof value.active === 'boolean'
    && (value.plan === null || typeof value.plan === 'string')
    && (value.renewalDate === null || typeof value.renewalDate === 'string')
    && Number.isSafeInteger(value.points) && value.points >= 0
    && (value.discountPercent === 0 || value.discountPercent === 15)
    && Array.isArray(value.earlyAccess) && value.earlyAccess.every((item) => typeof item === 'string')
    && Array.isArray(value.downloads) && value.downloads.every((item) => typeof item === 'string');
}

async function loadMembershipStatus(container) {
  const message = container.querySelector('[data-membership-message]');
  if (!message || container.dataset.authenticated !== 'true') return;
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 5000);
  try {
    const response = await fetch('/apps/idgit-membership/status', { credentials: 'same-origin', headers: { accept: 'application/json' }, signal: controller.signal });
    if (!response.ok) throw new Error('Unavailable');
    const status = await response.json();
    if (!isValidStatus(status)) throw new Error('Invalid status');
    message.textContent = status.active ? `Active member · ${status.discountPercent}% eligible-product benefit · ${status.points} points` : 'No active membership benefits';
  } catch {
    message.textContent = 'Membership benefits unavailable';
  } finally {
    clearTimeout(timeout);
  }
}

document.querySelectorAll('[data-idgit-membership-status]').forEach((container) => loadMembershipStatus(container));
document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll?.('[data-idgit-membership-status]').forEach((container) => loadMembershipStatus(container)));
